export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:9100'; 
export const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:9100';